import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { companyInfo, logoAltUrl } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'About', href: '#trust' },
    { label: 'Portfolio', href: '#portfolio' },
    { label: 'Contact', href: '#contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isScrolled ? 'bg-black/95 backdrop-blur-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-[7.6923%]">
        <div className="flex items-center justify-between h-24">
          {/* Logo - Higher resolution version */}
          <a href="#" className="flex items-center gap-3">
            <img
              src={logoAltUrl}
              alt="Nexline Electrical"
              className="h-20 w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-neutral-400 hover:text-white text-lg font-normal transition-colors duration-300"
              >
                {link.label}
              </a>
            ))}
            <Link
              to="/blog"
              data-testid="header-blog-link"
              className="text-neutral-400 hover:text-white text-lg font-normal transition-colors duration-300"
            >
              Blog
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center gap-2 text-white hover:text-electric-yellow transition-colors duration-300"
            >
              <Phone size={18} />
              <span className="text-sm font-medium">{companyInfo.phone}</span>
            </a>
            <a
              href="#contact"
              className="bg-electric-yellow text-black px-6 py-3 text-base font-medium hover:bg-transparent hover:text-electric-yellow border border-electric-yellow transition-all duration-400"
            >
              Get Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-sm border-t border-white/10">
            <nav className="flex flex-col py-6">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-neutral-400 hover:text-white px-6 py-3 text-lg transition-colors"
                >
                  {link.label}
                </a>
              ))}
              <Link
                to="/blog"
                data-testid="mobile-header-blog-link"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-neutral-400 hover:text-white px-6 py-3 text-lg transition-colors"
              >
                Blog
              </Link>
              <div className="px-6 pt-4 border-t border-white/10 mt-4">
                <a
                  href="#contact"
                  className="block bg-electric-yellow text-black px-6 py-3 text-center font-medium"
                >
                  Get Quote
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
